module.exports = __webpack_public_path__ + "media/images/marcador_ioscor2-9bc99c02938ef30761c34b08f90f0499.jpg";